var _path, _g, _path2, _g2, _path3, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRunWorks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2830,
    height: 146,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 966,
    height: 146,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h966v146H0V0Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#c)",
    d: "M449 4v132.5h38V91h8l24.5 45.5H565L532 82c8.333-3 25-14.8 25-38 0-29-26-40-44-40m-64 0h64Zm0 0h64Zm372 51c28.5 8.5 42 23 39.5 44S841 139 805 139c-28.8 0-49.667-12.333-56.5-18.5l18-28.5c6 6 17.5 13 30.5 14.5s25.5 0 25.5-7.5c0-3.5 0-8-25.5-14s-42.5-19.5-42.5-41 18-43.5 53-43.5c28 0 46.333 12 52 18L841 46c-3.167-3.167-12.5-10.1-24.5-12.5-15-3-25.5 2-25 7.5.486 5.35.973 5.496 27.244 13.327M821 55l-2.256-.673Zm0 0-2.256-.673ZM53 4l41 132.5h36l21-77 21 77h36L249.5 4H211l-19.5 73-21-73H133l-21.5 73-19-73H53Zm288-4c24 .5 71.9 15 71.5 69-.5 67.5-67.5 70-71.5 70s-71.5-3-71.5-70c0-53.6 47.667-68.333 71.5-69Zm-31.5 69c0-15.5 10.5-32.5 31.5-32.5s31.5 17 31.5 32.5-7.5 34.5-31.5 34.5-31.5-19-31.5-34.5ZM487 34.5h18c4.5-.167 13.5 2.3 13.5 13.5s-9 12.667-13.5 12h-18V34.5ZM598 4v132.5h38V107l11.5-12.5 31.5 42h49.5l-55-70.5 49-62h-48l-39 49.5L636 4h-38Z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    width: 966,
    height: 146,
    x: 966,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M966 0h966v146H966V0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#e)",
    d: "M1415 4v132.5h38V91h8l24.5 45.5h45.5L1498 82c8.33-3 25-14.8 25-38 0-29-26-40-44-40m-64 0h64Zm0 0h64Zm372 51c28.5 8.5 42 23 39.5 44s-19.5 40-55.5 40c-28.8 0-49.67-12.333-56.5-18.5l18-28.5c6 6 17.5 13 30.5 14.5s25.5 0 25.5-7.5c0-3.5 0-8-25.5-14s-42.5-19.5-42.5-41 18-43.5 53-43.5c28 0 46.33 12 52 18L1807 46c-3.17-3.167-12.5-10.1-24.5-12.5-15-3-25.5 2-25 7.5.49 5.35.97 5.496 27.24 13.327M1787 55l-2.26-.673Zm0 0-2.26-.673ZM1019 4l41 132.5h36l21-77 21 77h36L1215.5 4H1177l-19.5 73-21-73H1099l-21.5 73-19-73H1019Zm288-4c24 .5 71.9 15 71.5 69-.5 67.5-67.5 70-71.5 70s-71.5-3-71.5-70c0-53.6 47.67-68.333 71.5-69Zm-31.5 69c0-15.5 10.5-32.5 31.5-32.5s31.5 17 31.5 32.5-7.5 34.5-31.5 34.5-31.5-19-31.5-34.5ZM1453 34.5h18c4.5-.167 13.5 2.3 13.5 13.5s-9 12.667-13.5 12h-18V34.5ZM1564 4v132.5h38V107l11.5-12.5 31.5 42h49.5l-55-70.5 49-62h-48l-39 49.5.5-49.5h-38Z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    width: 966,
    height: 146,
    x: 1932,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1932 0h966v146h-966V0Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#g)",
    d: "M2381 4v132.5h38V91h8l24.5 45.5h45.5L2464 82c8.33-3 25-14.8 25-38 0-29-26-40-44-40m-64 0h64Zm0 0h64Zm372 51c28.5 8.5 42 23 39.5 44s-19.5 40-55.5 40c-28.8 0-49.67-12.333-56.5-18.5l18-28.5c6 6 17.5 13 30.5 14.5s25.5 0 25.5-7.5c0-3.5 0-8-25.5-14s-42.5-19.5-42.5-41 18-43.5 53-43.5c28 0 46.33 12 52 18L2773 46c-3.17-3.167-12.5-10.1-24.5-12.5-15-3-25.5 2-25 7.5.49 5.35.97 5.496 27.24 13.327M2753 55l-2.26-.673Zm0 0-2.26-.673ZM1985 4l41 132.5h36l21-77 21 77h36L2181.5 4H2143l-19.5 73-21-73H2065l-21.5 73-19-73H1985Zm288-4c24 .5 71.9 15 71.5 69-.5 67.5-67.5 70-71.5 70s-71.5-3-71.5-70c0-53.6 47.67-68.333 71.5-69Zm-31.5 69c0-15.5 10.5-32.5 31.5-32.5s31.5 17 31.5 32.5-7.5 34.5-31.5 34.5-31.5-19-31.5-34.5ZM2419 34.5h18c4.5-.167 13.5 2.3 13.5 13.5s-9 12.667-13.5 12h-18V34.5ZM2530 4v132.5h38V107l11.5-12.5 31.5 42h49.5l-55-70.5 49-62h-48l-39 49.5.5-49.5h-38Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -46.51,
    x2: 158.284,
    y1: 106.153,
    y2: -301.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#EDD1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE052"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 919.49,
    x2: 1124.28,
    y1: 106.153,
    y2: -301.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#EDD1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE052"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 1885.49,
    x2: 2090.28,
    y1: 106.153,
    y2: -301.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#EDD1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE052"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h2830v146H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunWorks);
export default __webpack_public_path__ + "static/media/run_works.2270b53c2173b1e311823244fca51839.svg";
export { ForwardRef as ReactComponent };